import { SUPPORTED_VIDEO_CODECS } from '@anm/constants/supports';

var isSupportedCodec = function isSupportedCodec(video) {
  return video.codec && SUPPORTED_VIDEO_CODECS.includes(video.codec);
};

export default isSupportedCodec;